'use strict'
import Vue from 'vue'
import Vuex from 'vuex'
import LoginStore from '../pages/auth/login.store.js'
import MainLayoutStore from './main.layout.store.js'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'prod', // [ext] open vuex strict mode
  modules: {
    login: LoginStore,
    frame: MainLayoutStore
  }
})



// WEBPACK FOOTER //
// ./src/services/store.provider.js